import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dv_scroll_ranking_board = _resolveComponent("dv-scroll-ranking-board")!

  return (_openBlock(), _createBlock(_component_dv_scroll_ranking_board, {
    id: "hospital-rank",
    config: _ctx.config
  }, null, 8, ["config"]))
}